<template>
  <el-row :gutter="12" class="mt-2" v-loading.fullscreen.lock="users.isLoading">
    <el-row type="flex" justify="space-between" align="middle" class="mb-4">
      <p class="category-title ma-0">
        Staff Account
        <el-button
            @click="$router.push('/staff/create')"
            type="warning"
            icon="el-icon-plus"
            circle
            size="small"
            class="ml-3"
          ></el-button>
      </p>

      <el-col :span="16">
        <el-row type="flex" justify="end">
          <el-select
            v-model="optionView"
            size="small"
            placeholder="Select"
            @change="
            e => {
              toDetail(page, e), settingTable(page, e);
            }
          "
            class="mr-2"
            style="width: 100px"
          >
            <el-option
              v-for="item in optionsView"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            size="small"
            v-model="form.search"
            placeholder="Search by nik or name"
            style="width: 200px"
            class="mr-2"
            @keyup.enter.native="onSearch"
          ></el-input>
        </el-row>
      </el-col>
    </el-row>

    <el-col :span="24">
      <el-table empty-text="Tidak ada data" :data="users.data" style="width: 100%">
        <el-table-column type="index" label="No" width="180"></el-table-column>
        <el-table-column sortable prop="username" label="NIK" width="180"></el-table-column>
        <el-table-column sortable prop="fullname" label="Nama"></el-table-column>
        <el-table-column sortable prop="userType" label="User Type"></el-table-column>
        <el-table-column sortable prop="isActive" label="Status">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.isActive"
              placeholder="Select"
              @change="(e) => handleUpdate(e, scope.row.id)"
            >
              <el-option
                v-for="item in optionsActive"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="Operations">
          <template slot-scope="scope">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-edit"
              circle
              @click="$router.push(`/staff/edit/${scope.row.id}`)"
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              circle
              @click="handleDelete(scope.$index, scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="end">
        <el-pagination
          layout="prev, pager, next"
          :total="users.count"
          :current-page="parseInt(page)"
          @current-change="
            e => {
              toDetail(e, optionView), settingTable(e, optionView);
            }
          "
          :page-size="parseInt(optionView)"
        ></el-pagination>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      form: {
        search: ""
      },
      value: false,
      optionsActive: [
        {
          value: true,
          label: "Active"
        },
        {
          value: false,
          label: "No Active"
        }
      ],
      optionsView: [
        {
          value: 25,
          label: "25"
        },
        {
          value: 50,
          label: "50"
        },
        {
          value: 75,
          label: "75"
        },
        {
          value: 100,
          label: "100"
        },
        {
          value: 125,
          label: "125"
        },
        {
          value: 150,
          label: "150"
        }
      ],
      optionView: 25,
      dialog: false,
      id: null,
      page: 1
    };
  },
  mounted() { },
  methods: {
    ...mapActions({
      getUser: "user/GetUsers",
      deleteUser: "user/DeleteUser",
      updateStatusUser: "user/UpdateStatusUser"
    }),
    showDialog(id) {
      (this.id = id), (this.dialog = true);
    },
    handleUpdate(value, idx) {
      const body = {
        id: idx,
        isActive: value
      }
      this.updateStatusUser(body)
    },
    handleDelete(idx, row) {
      this.$confirm(
        "This will permanently delete the file. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.deleteUser(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled"
          });
        });
    },
    toDetail(page, limit) {
      this.$router.push({ path: "/staff", query: { page: page, limit: limit } });
    },
    onSearch() {
      this.$router.replace({ path: "/staff", query: { page: 1, limit: 25, search: this.form.search } })
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search
        }
      };
      this.getUser(option);
    },
    settingTable() {
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView
        }
      };
      this.getUser(option);
    }
  },
  computed: {
    ...mapState({
      users: state => state.user.adminAndStaff
    })
  },
  watch: {
    users: {
      handler(newValue) {
        if (!newValue.isLoading && !newValue.error) {
          this.dialog = false;
        }
      },
      deep: true
    }
  },
  created() {
    this.page = this.$router.history.current.query.page;
    this.optionView = this.$router.history.current.query.limit;
    let option = {
      params: {
        page: this.page,
        limit: this.optionView
      }
    };
    this.getUser(option);
  }
};
</script>

<style>
.category-title {
  text-align: left;
  font-size: 1.5rem;
}
</style>
